export { default as Collection } from './Collection'
